<div class="driver-popup">
  <div class="driver-popup__heading">
    <img [src]="carIconUrl" width="45px" height="45px" />
    <div class="driver-popup__heading--description">
      <b [innerHTML]="vehicleDescription"></b>
    </div>
  </div>
  <div class="driver-popup__separator"></div>
  <div class="driver-popup__body">
    <div class="driver-popup__driver-info">
      <div class="info-heading-text">
        {{ 'VehicleDriverPopup.DefaultDriver' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ userDescription || '-' }}</b>
      </div>
      <div class="info-body-text">
        <b>({{ userName || '-' }})</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'VehicleDriverPopup.Mobile' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ userMobile || '-' }}</b>
      </div>
    </div>
  </div>
  @if (
    userStatusKey() && userStatusKey() !== keyUserNoStatus && userStatusKey();
    as status
  ) {
    <div class="user-status">
      <div>
        <span
          class="dv-icons user-status__text"
          [style.color]="UserStatusIcons[status]?.color"
          >{{ UserStatusIcons[status]?.icon }}</span
        >
      </div>
      <div class="user-status__text">
        {{ status | translate }}
      </div>
    </div>
  }
  <div class="driver-popup__last-activity">
    <div class="driver-popup__last-activity--mins">
      <b>
        {{ 'VehicleDriverPopup.LastActivity' | translate }}:
        @if (lastActivityTime) {
          <span>{{ lastActivityTime | dateAgo }}</span>
        }
      </b>
    </div>
    <div class="driver-popup__last-activity--date">
      {{
        lastActivityTime ? (lastActivityTime | date: 'dd.MM.yyyy, H:mm') : '-'
      }}
    </div>
  </div>

  @if (mapsUrl) {
    <div class="driver-popup__maps" (click)="openInGoogleMaps(mapsUrl)">
      <img
        [dvTooltip]="'VehicleDriverPopup.OpenInGoogleMaps' | translate"
        [src]="'./assets/google-maps.svg'" />
    </div>
  }
  @if (showGeofence === 'true') {
    <div class="driver-popup__geofence-wrapper">
      @if (hasTemporaryGeofence === 'true') {
        <div class="driver-popup__geofence-set">
          <app-geofence-info-box
            class="driver-popup__geofence-set--info-box"
            [isGeofenceSet]="true"></app-geofence-info-box>
          <div class="driver-popup__geofence-set--info-btn">
            <dv-button
              color="secondary"
              icon="info"
              [tooltip]="'General.GeofenceSet' | translate"></dv-button>
          </div>
        </div>
        <div class="driver-popup__delete-geofence">
          <dv-button
            color="danger"
            (click)="onGeofenceDeleteClicked(geofenceId)">
            {{ 'General.DeleteGeofence' | translate | uppercase }}</dv-button
          >
        </div>
      } @else {
        <div class="driver-popup__geofence-not-set">
          <dv-button
            [disabled]="!(canEditTempGeofence$ | async)"
            color="secondary"
            icon="shape_polygon_plus"
            (click)="onCreateTempGeofenceClick()"
            >{{ 'General.QuickGeofence' | translate | uppercase }}</dv-button
          >
        </div>
      }
    </div>
  }
</div>
